import { render, staticRenderFns } from "./BrancheItem.vue?vue&type=template&id=34d882aa&scoped=true&"
import script from "./BrancheItem.vue?vue&type=script&lang=js&"
export * from "./BrancheItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d882aa",
  null
  
)

export default component.exports